import { AUTH_TOKEN_STORAGE_KEY } from 'src/pages/Login/constants';
import { CookieHelper } from './helpers';

export const getAuthBearerToken = () => {
  const token = CookieHelper.get(AUTH_TOKEN_STORAGE_KEY);

  if (typeof token !== 'string' || !token) {
    console.warn('No auth token found in cookies');
    return null;
  }

  return `Bearer ${token}`;
};

export const getHeadersWithBearerToken = () => {
  const bearerToken = getAuthBearerToken();

  if (!bearerToken) {
    throw new Error('Missing bearerToken');
  }

  const headers = new Headers();
  headers.set('Authorization', bearerToken);

  return headers;
};
